import './ProductFloatActionBar.less';
import React, {useState, useEffect} from 'react';
import LayoutPortal from "../../../layout/components/layout-portal/LayoutPortal";
import Icon from "../../../components/icon/Icon";
import __ from "../../../i18n";
import {getLayoutScrollElement} from "../../../dom/element/query";


export default function ProductFloatActionBar({orderButton, hotline, buyNow}) {

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        (getLayoutScrollElement() || window).addEventListener('scroll', function () {
            const rect = orderButton.getBoundingClientRect();
            if (rect.bottom > 0) {
                setVisible(false);
            } else {
                setVisible(true);
            }
        });
    }, []);

    if (!visible) {
        return null;
    }

    return <LayoutPortal>
        <div className="product-float-action-bar">
            {
                hotline &&
                <a className="call-button" href={`tel:${hotline}`}>
                    <Icon name="hotline"/>
                    <span>{__('Free consult')}</span>
                </a>
            }
            <a className="buy-now-button" onClick={() => buyNow()}>
                <span>{__('Buy now')}</span>
            </a>
        </div>
    </LayoutPortal>;
}
